import ReglaEtiquetaCreate from './ReglaEtiquetaCreate';
import ReglaEtiquetaEdit from './ReglaEtiquetaEdit';

const indexReglaEtiqueta = {
    create: ReglaEtiquetaCreate,
    edit: ReglaEtiquetaEdit,
};

export default indexReglaEtiqueta;
